import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { mergeLeaveDetails, withDefaultLeave } from '../schemas/hr-term-schema';
import { HrInfoValues } from '../schemas/employee-form-schema';
import { useLeaveCategoriesLookup } from './use-leave-lookups';

/**
 * Keeps the leave categories of every HR term in step with the categories of the active organization: they are the rows of each term's leave allotment, with a default leave picked for terms that have none yet. It runs at the HR Info form level so terms the user
 * has not opened yet are filled too and validate correctly.
 */
export const useSyncLeaveDetails = (form: UseFormReturn<HrInfoValues>, enabled = true) => {
  const { categories } = useLeaveCategoriesLookup(enabled);

  useEffect(() => {
    if (!enabled || !categories) return;
    form.getValues('HrTerms').forEach((term, index) => {
      const merged = withDefaultLeave(
        mergeLeaveDetails(categories, term.LeaveDetails),
        term.EmploymentType
      );
      if (JSON.stringify(merged) !== JSON.stringify(term.LeaveDetails)) {
        form.setValue(`HrTerms.${index}.LeaveDetails`, merged);
      }
    });
  }, [categories, enabled, form]);
};
